import {useEffect, useState, useCallback, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';

import {useSearchClickLog} from '@/components/search/common/hooks/useSearchClickLog';
import {useSearchGlobalStatus} from '@/components/search/SearchProvider';
import useUrlParameter from '@/components/search/common/hooks/useUrlParameter';

/**
 * SuggestKeywordGroup 컴포넌트 ( 검색어제안 )
 * @param {object} props 컴포넌트의 props
 * @param {object} stopWordInfo 검색어 제안 데이터
 * @returns StreamerProfileGroup 컴포넌트
 */
const SuggestKeywordGroup = ({stopWordInfo}) => {
  const navigate = useNavigate();
  const {getParams} = useUrlParameter();
  const {szSearchType = 'total'} = getParams();

  const {sessionKey} = useSearchGlobalStatus();
  const {sendSuggestKeywordClickLog} = useSearchClickLog();

  const [stopWord, setStopWord] = useState({});

  const hasSuggest =
    stopWord && stopWord.modified && typeof stopWord.isAutofix !== 'undefined';

  const isAutofix =
    stopWord &&
    stopWord.modified &&
    typeof stopWord.isAutofix !== 'undefined' &&
    stopWord.isAutofix === true;

  // SCKACT 로그
  const handleSuggestKeywordClick = useCallback(
    (e) => {
      e.preventDefault();

      sendSuggestKeywordClickLog({
        sessionKey: sessionKey,
      });

      let searchParams = {
        szLocation: 'total_search',
        szSearchType: hasSuggest ? szSearchType : 'total',
        szStype: 'mk',
        szOriginalKeyword: stopWord.origin,
        szModifiedKeyword: '',
        szKeyword: isAutofix ? stopWord.origin : stopWord.modified,
        rs: '1',
        acttype: 'mk',
      };

      if (hasSuggest) {
        searchParams = {
          ...searchParams,
          hasRemoveSuggest: 'true',
        };
      }
      searchParams = new URLSearchParams(searchParams);
      navigate(`/search?${searchParams.toString()}`);
    },
    [getParams, sendSuggestKeywordClickLog, hasSuggest, isAutofix, sessionKey],
  );

  useEffect(() => {
    setStopWord(stopWordInfo);
  }, [stopWordInfo]);

  const searchUrl = useMemo(() => {
    return `/search?szLocation=total_search&szSearchType=${hasSuggest ? szSearchType : 'total'}&szStype=mk&szOriginalKeyword=${stopWord.origin}&szModifiedKeyword=${stopWord.modified}&szKeyword=${
      hasSuggest
        ? isAutofix
          ? stopWord.origin
          : stopWord.modified
        : stopWord.origin
    }&rs=1&acttype=mk&sessionKey=${sessionKey}${hasSuggest ? '&hasRemoveSuggest=true' : ''}`;
  }, [
    hasSuggest,
    szSearchType,
    stopWord.origin,
    stopWord.modified,
    isAutofix,
    sessionKey,
  ]);

  return (
    <>
      {stopWord && stopWord.modified && !stopWord.isAutofix && (
        <div className='suggest_area'>
          <div className='result_txt'>
            <span className='txt'>이것을 찾으셨나요?</span>
            <a href={searchUrl} onClick={handleSuggestKeywordClick}>
              <em>{stopWord.modified} </em>
              <span className='show'>검색결과 보기</span>
            </a>
          </div>
        </div>
      )}

      {/* original 로 서버에서 먼저 조회 처리*/}
      {stopWord && stopWord.modified && stopWord.isAutofix && (
        <div className='suggest_area'>
          <div className='result_txt'>
            <div className='txt'>
              <em>{stopWord.modified}</em>
              <span>{stopWord.postpos} 수정된 결과입니다.</span>
            </div>
            <a href={searchUrl} onClick={handleSuggestKeywordClick}>
              <em>{stopWord.origin}</em>
              <span className='show'>검색결과 보기</span>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default SuggestKeywordGroup;
